import NotificationPanel from '@helsenorge/designsystem-react/components/NotificationPanel';

import SafeHTML, { type MarkdownType } from '@helsenorge/framework-utils/components/safe-html';

import NotificationPanelWrapper from '../notificationpanel-wrapper';

interface WarningProps {
  html: string | MarkdownType;
  testId?: string;
}

const Warning: React.FC<WarningProps> = (props: WarningProps) => {
  return (
    <NotificationPanelWrapper>
      <NotificationPanel variant="info" size="large" testId={props.testId}>
        <SafeHTML html={props.html} tagName="div" type="markdown" />
      </NotificationPanel>
    </NotificationPanelWrapper>
  );
};

export default Warning;
